import {
  Component,
  AfterContentInit,
  ContentChildren,
  QueryList,
  EventEmitter,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { PgFieldComponent } from '../../pg-field.component';
import { PgFieldGridColumnDirective } from '../pg-field-grid-column.directive';

@Component({
  selector: 'pg-field-grid-row',
  templateUrl: './pg-field-grid-row.component.html',
  styleUrls: ['./pg-field-grid-row.component.scss'],
})
export class PgFieldGridRowComponent implements AfterContentInit {
  // Direct children will be templates because they are pgFields decorated
  // with *pgFieldGridCol
  @ContentChildren(PgFieldGridColumnDirective) _templateChildren: QueryList<
    PgFieldGridColumnDirective
  >;

  @ContentChildren(PgFieldComponent, { descendants: true })
  _componentChildren: QueryList<PgFieldComponent>;

  columns: { cols: any; child: PgFieldGridColumnDirective }[];
  fields: PgFieldComponent[];

  notifyFieldsChange = new EventEmitter<void>();

  get hostElement(): ElementRef {
    return this.elementRef.nativeElement;
  }
  constructor(public elementRef: ElementRef) {}

  ngAfterContentInit() {
    this._initializeRowSpread();
  }

  getColClass(cols) {
    return `col-sm-12 col-md-12 col-lg-${cols}`;
  }

  private _initializeRowSpread() {
    let remainingCols = 12;
    let autoCount = 0;
    let autoWidth = 12;
    this._templateChildren.forEach(c => {
      if (c.width && c.width !== 'auto') {
        remainingCols -= c.width;
      } else {
        autoCount++;
      }
    });

    if (remainingCols > 0) {
      autoWidth = Math.floor(remainingCols / autoCount);
    }

    this.columns = this._templateChildren.map((c, index, arr) => {
      let cols;
      if (!c.width || c.width === 'auto') {
        cols = autoWidth;
      } else {
        cols = c.width;
      }

      return {
        cols: cols,
        child: c,
      };
    });
  }
}
